var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSparklerIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "sparkler 1"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    opacity: 0.964,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.6797 1.47656C15.8903 2.50763 16.32 3.44513 16.9688 4.28906C17.7523 5.14598 18.7133 5.70848 19.8516 5.97656C17.5158 6.59363 16.1408 8.09363 15.7266 10.4766C15.3123 8.09363 13.9373 6.59363 11.6016 5.97656C13.9468 5.36592 15.3061 3.86592 15.6797 1.47656Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    opacity: 0.981,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.92969 4.47656C9.192 6.0518 9.73106 7.53614 10.5469 8.92969C11.9568 11.1112 13.9334 12.5018 16.4766 13.1016C12.8495 14.049 10.4823 16.3146 9.375 19.8984C9.20512 20.4998 9.07233 21.1092 8.97656 21.7266C8.62575 19.0008 7.42261 16.743 5.36719 14.9531C4.20729 14.0608 2.91042 13.4436 1.47656 13.1016C5.30967 12.0731 7.72373 9.63562 8.71875 5.78906C8.83458 5.35838 8.90489 4.92089 8.92969 4.47656Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_3"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    opacity: 0.964,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.3047 13.4766C18.5153 14.5076 18.945 15.4451 19.5938 16.2891C20.3773 17.146 21.3383 17.7085 22.4766 17.9766C20.1408 18.5936 18.7658 20.0936 18.3516 22.4766C17.9373 20.0936 16.5623 18.5936 14.2266 17.9766C16.5718 17.3659 17.9311 15.8659 18.3047 13.4766Z",
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSparklerIcon);
export default __webpack_public_path__ + "static/media/sparkler_icon.1e5074679ccb61b1595277cc7dddffaf.svg";
export { ForwardRef as ReactComponent };